import { Flex, Text, Box } from '@chakra-ui/react';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
  isLoading: boolean;
}

const DeleteDraftModal = ({ onRemove, isOpen, onClose, isLoading }: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    width="450px"
    closeButtonProps={{
      hidden: true
    }}
  >
    <Flex
      flexDirection={'column'}
      gap={4}
      padding={8}
      justifyContent={'center'}
    >
      <Box color="actionSecondaryCautionContent" fontSize="40px">
        <FontAwesomeIcon icon={faTriangleExclamation} />
      </Box>
      <Text textStyle="headingGroup">Delete Draft?</Text>
      <Text textStyle="textBody">
        This action is irreversible, and you will need to resubmit your work.
        Are you sure you want to continue?
      </Text>
      <Flex justifyContent="flex-end" gap={2} alignItems="center">
        <Button onClick={onClose} variant="secondary" isDisabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="caution"
          onClick={onRemove}
          isDisabled={isLoading}
          isLoading={isLoading}
        >
          Delete Draft
        </Button>
      </Flex>
    </Flex>
  </Modal>
);

export default DeleteDraftModal;
